import type { AssignRouteFormValues } from "app/components/Modal/AssignRouteModal";
import dayjs from "dayjs";
import type { AssignPickingsPayload } from "app/utils/odooApi";

export function buildAssignPickingsPayload(
  formValues: AssignRouteFormValues,
  pickingIds: number[]
): AssignPickingsPayload {
  if (formValues.driverId === "") {
    throw new Error("Please select a driver.");
  }

  const payload: AssignPickingsPayload = {
    picking_ids: pickingIds,
    driver_id: formValues.driverId,
  };

  if (formValues.mode === "existing") {
    if (formValues.routeId === "") {
      throw new Error("Please select a route.");
    }
    payload.route_id = formValues.routeId;
    payload.create_new_route = false;
    return payload;
  }

  payload.create_new_route = true;
  payload.date = dayjs(formValues.date).format("YYYY-MM-DD");

  const startTime = formValues.startTime.trim();
  const finishTime = formValues.finishTime.trim();
  if (startTime) {
    payload.start_time = startTime;
  }
  if (finishTime) {
    payload.finish_time = finishTime;
  }
  if (formValues.depotId) {
    payload.depot_id = formValues.depotId;
  }
  payload.is_round_trip = formValues.isRoundTrip;

  return payload;
}
